import TranslationNS from '@/utils/Constants/TranslationNS'

const CONTRACT = TranslationNS.CONTRACT_SIGNATURE

/**
 * Contracts › « Paramètres » — athlete (`contract`) and volunteer (`staff/contract`) contract, one
 * tour for both audiences: state, counts and Unpublish; the PDF preview (in the head); the requests
 * block and its blockers; title + deadline; the text and its PDF limits; Save as draft / Publish and
 * what each dialog asks.
 */
export const CONTRACT_SETTINGS_TOUR = {
    id: 'contract-settings',
    version: 1,
    paths: ['contract', 'staff/contract'],
    steps: [
        {
            key: 'head',
            target: '[data-tour="page-head"]',
            placement: 'bottom',
            title: 'The contract to sign',
            description:
                'The document your athletes or volunteers must sign. Its state and the number of signatures and requests show here.',
            entries: [
                {
                    label: 'Unpublish',
                    ns: CONTRACT,
                    text: 'appears once published: takes the contract offline after a confirmation.',
                },
            ],
        },
        {
            key: 'preview',
            target: '[data-tour="ctr-preview"]',
            placement: 'bottom',
            title: 'See the PDF',
            description:
                'Shows the contract as the signers will receive it. Available once title, deadline and text are filled.',
        },
        {
            key: 'requests',
            target: '[data-tour="ctr-requests"]',
            placement: 'bottom',
            title: 'Ask for signatures',
            description:
                'Once the contract is published, this button e-mails every registrant a link to sign. If something blocks it, a dialog says what. One reminder per person every 3 days at most.',
        },
        {
            key: 'fields',
            target: '[data-tour="ctr-fields"]',
            placement: 'bottom',
            title: 'Title and deadline',
            description:
                'Give the contract a title and the date after which it can no longer be signed: it is unpublished by itself then.',
        },
        {
            key: 'content',
            target: '[data-tour="ctr-content"]',
            scroll: 'start',
            placement: 'bottom',
            title: 'The contract text',
            description:
                'Write the contract here. It becomes a PDF: text and images only, no tables or embedded media. The signature sits right under it.',
        },
        {
            key: 'save',
            target: '[data-tour="page-save"]',
            placement: 'bottom',
            placementNarrow: 'top',
            title: 'Save or publish',
            description:
                'The line counts your unsaved changes; « Discard » drops them. Changing the title or the text later deletes the signatures already collected: you confirm first.',
            entries: [
                {
                    label: 'Save as draft',
                    ns: CONTRACT,
                    text: 'keeps your changes without making the contract signable.',
                },
                {
                    label: 'Publish',
                    ns: CONTRACT,
                    text: 'makes the contract signable and offers to send the requests right away.',
                },
            ],
        },
    ],
}

export default CONTRACT_SETTINGS_TOUR
